import React from 'react';
import { useParams } from 'react-router-dom';
import CreateResourceAllocation from './CreateResourceAllocation';

const EditResourceAllocation = () => {
  const { id } = useParams();
  return <CreateResourceAllocation editMode={true} allocationId={id} />;
};

export default EditResourceAllocation;
